import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx';

// Development-only: Detect when objects are rendered as React children
if (import.meta.env?.DEV) {
  (async () => {
    const ReactModule = await import('react');
    const ReactAny: any = ReactModule.default ?? ReactModule;
    const origCreateElement = ReactAny.createElement;

    ReactAny.createElement = (type: any, props: any, ...children: any[]) => {
      const flat = children.flat?.(Infinity) ?? children;
      for (const ch of flat) {
        if (ch == null) continue;
        
        const isReactEl = ch && typeof ch === 'object' && ('$$typeof' in ch);
        const isRenderable =
          typeof ch === 'string' ||
          typeof ch === 'number' ||
          typeof ch === 'boolean' ||
          isReactEl;
        
        if (!isRenderable && typeof ch === 'object') {
          const compName = typeof type === 'function' 
            ? (type.displayName || type.name || 'Anonymous') 
            : String(type);
          
          console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
          console.error('🚨 [Object-as-child detected] 🚨');
          console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
          console.error('Component:', compName);
          console.error('Child type:', typeof ch);
          console.error('Child value:', ch);
          console.error('Props keys:', props ? Object.keys(props) : []);
          console.error('Props:', props);
          console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
          
          // Uncomment to pause debugger when this happens
          // debugger;
        }
      }
      return origCreateElement(type, props, ...children);
    };
  })();
}

// Fix for non-passive wheel event listener warning
// This makes wheel events passive by default to improve scroll performance
const originalAddEventListener = EventTarget.prototype.addEventListener;
EventTarget.prototype.addEventListener = function(type, listener, options) {
  if (type === 'wheel' && typeof options === 'boolean') {
    options = { passive: true, capture: options };
  } else if (type === 'wheel' && typeof options === 'object' && options !== null) {
    options = { ...options, passive: true };
  } else if (type === 'wheel') {
    options = { passive: true };
  }
  return originalAddEventListener.call(this, type, listener, options);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
